import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/random/iter/arcsine';
import __var_2__ from '@stdlib/random/iter/bernoulli';
import __var_3__ from '@stdlib/random/iter/beta';
import __var_4__ from '@stdlib/random/iter/betaprime';
import __var_5__ from '@stdlib/random/iter/binomial';
import __var_6__ from '@stdlib/random/iter/box-muller';
import __var_7__ from '@stdlib/random/iter/cauchy';
import __var_8__ from '@stdlib/random/iter/chi';
import __var_9__ from '@stdlib/random/iter/chisquare';
import __var_10__ from '@stdlib/random/iter/cosine';
import __var_11__ from '@stdlib/random/iter/discrete-uniform';
import __var_12__ from '@stdlib/random/iter/erlang';
import __var_13__ from '@stdlib/random/iter/exponential';
import __var_14__ from '@stdlib/random/iter/f';
import __var_15__ from '@stdlib/random/iter/frechet';
import __var_16__ from '@stdlib/random/iter/gamma';
import __var_17__ from '@stdlib/random/iter/geometric';
import __var_18__ from '@stdlib/random/iter/gumbel';
import __var_19__ from '@stdlib/random/iter/hypergeometric';
import __var_20__ from '@stdlib/random/iter/improved-ziggurat';
import __var_21__ from '@stdlib/random/iter/invgamma';
import __var_22__ from '@stdlib/random/iter/kumaraswamy';
import __var_23__ from '@stdlib/random/iter/laplace';
import __var_24__ from '@stdlib/random/iter/levy';
import __var_25__ from '@stdlib/random/iter/logistic';
import __var_26__ from '@stdlib/random/iter/lognormal';
import __var_27__ from '@stdlib/random/iter/minstd';
import __var_28__ from '@stdlib/random/iter/minstd-shuffle';
import __var_29__ from '@stdlib/random/iter/mt19937';
import __var_30__ from '@stdlib/random/iter/negative-binomial';
import __var_31__ from '@stdlib/random/iter/normal';
import __var_32__ from '@stdlib/random/iter/pareto-type1';
import __var_33__ from '@stdlib/random/iter/poisson';
import __var_34__ from '@stdlib/random/iter/randi';
import __var_35__ from '@stdlib/random/iter/randn';
import __var_36__ from '@stdlib/random/iter/randu';
import __var_37__ from '@stdlib/random/iter/rayleigh';
import __var_38__ from '@stdlib/random/iter/t';
import __var_39__ from '@stdlib/random/iter/triangular';
import __var_40__ from '@stdlib/random/iter/uniform';
import __var_41__ from '@stdlib/random/iter/weibull';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name arcsine
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/arcsine}
*/
setReadOnly( ns, 'arcsine', __var_1__);

/**
* @name bernoulli
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/bernoulli}
*/
setReadOnly( ns, 'bernoulli', __var_2__);

/**
* @name beta
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/beta}
*/
setReadOnly( ns, 'beta', __var_3__);

/**
* @name betaprime
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/betaprime}
*/
setReadOnly( ns, 'betaprime', __var_4__);

/**
* @name binomial
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/binomial}
*/
setReadOnly( ns, 'binomial', __var_5__);

/**
* @name boxMuller
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/box-muller}
*/
setReadOnly( ns, 'boxMuller', __var_6__);

/**
* @name cauchy
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/cauchy}
*/
setReadOnly( ns, 'cauchy', __var_7__);

/**
* @name chi
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/chi}
*/
setReadOnly( ns, 'chi', __var_8__);

/**
* @name chisquare
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/chisquare}
*/
setReadOnly( ns, 'chisquare', __var_9__);

/**
* @name cosine
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/cosine}
*/
setReadOnly( ns, 'cosine', __var_10__);

/**
* @name discreteUniform
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/discrete-uniform}
*/
setReadOnly( ns, 'discreteUniform', __var_11__);

/**
* @name erlang
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/erlang}
*/
setReadOnly( ns, 'erlang', __var_12__);

/**
* @name exponential
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/exponential}
*/
setReadOnly( ns, 'exponential', __var_13__);

/**
* @name f
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/f}
*/
setReadOnly( ns, 'f', __var_14__);

/**
* @name frechet
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/frechet}
*/
setReadOnly( ns, 'frechet', __var_15__);

/**
* @name gamma
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/gamma}
*/
setReadOnly( ns, 'gamma', __var_16__);

/**
* @name geometric
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/geometric}
*/
setReadOnly( ns, 'geometric', __var_17__);

/**
* @name gumbel
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/gumbel}
*/
setReadOnly( ns, 'gumbel', __var_18__);

/**
* @name hypergeometric
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/hypergeometric}
*/
setReadOnly( ns, 'hypergeometric', __var_19__);

/**
* @name improvedZiggurat
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/improved-ziggurat}
*/
setReadOnly( ns, 'improvedZiggurat', __var_20__);

/**
* @name invgamma
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/invgamma}
*/
setReadOnly( ns, 'invgamma', __var_21__);

/**
* @name kumaraswamy
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/kumaraswamy}
*/
setReadOnly( ns, 'kumaraswamy', __var_22__);

/**
* @name laplace
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/laplace}
*/
setReadOnly( ns, 'laplace', __var_23__);

/**
* @name levy
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/levy}
*/
setReadOnly( ns, 'levy', __var_24__);

/**
* @name logistic
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/logistic}
*/
setReadOnly( ns, 'logistic', __var_25__);

/**
* @name lognormal
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/lognormal}
*/
setReadOnly( ns, 'lognormal', __var_26__);

/**
* @name minstd
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/minstd}
*/
setReadOnly( ns, 'minstd', __var_27__);

/**
* @name minstdShuffle
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/minstd-shuffle}
*/
setReadOnly( ns, 'minstdShuffle', __var_28__);

/**
* @name mt19937
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/mt19937}
*/
setReadOnly( ns, 'mt19937', __var_29__);

/**
* @name negativeBinomial
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/negative-binomial}
*/
setReadOnly( ns, 'negativeBinomial', __var_30__);

/**
* @name normal
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/normal}
*/
setReadOnly( ns, 'normal', __var_31__);

/**
* @name pareto1
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/pareto-type1}
*/
setReadOnly( ns, 'pareto1', __var_32__);

/**
* @name poisson
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/poisson}
*/
setReadOnly( ns, 'poisson', __var_33__);

/**
* @name randi
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/randi}
*/
setReadOnly( ns, 'randi', __var_34__);

/**
* @name randn
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/randn}
*/
setReadOnly( ns, 'randn', __var_35__);

/**
* @name randu
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/randu}
*/
setReadOnly( ns, 'randu', __var_36__);

/**
* @name rayleigh
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/rayleigh}
*/
setReadOnly( ns, 'rayleigh', __var_37__);

/**
* @name t
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/t}
*/
setReadOnly( ns, 't', __var_38__);

/**
* @name triangular
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/triangular}
*/
setReadOnly( ns, 'triangular', __var_39__);

/**
* @name uniform
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/uniform}
*/
setReadOnly( ns, 'uniform', __var_40__);

/**
* @name weibull
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/iter/weibull}
*/
setReadOnly( ns, 'weibull', __var_41__);


// EXPORTS //
export default ns;

export { __var_1__ as arcsine, __var_2__ as bernoulli, __var_3__ as beta, __var_4__ as betaprime, __var_5__ as binomial, __var_6__ as boxMuller, __var_7__ as cauchy, __var_8__ as chi, __var_9__ as chisquare, __var_10__ as cosine, __var_11__ as discreteUniform, __var_12__ as erlang, __var_13__ as exponential, __var_14__ as f, __var_15__ as frechet, __var_16__ as gamma, __var_17__ as geometric, __var_18__ as gumbel, __var_19__ as hypergeometric, __var_20__ as improvedZiggurat, __var_21__ as invgamma, __var_22__ as kumaraswamy, __var_23__ as laplace, __var_24__ as levy, __var_25__ as logistic, __var_26__ as lognormal, __var_27__ as minstd, __var_28__ as minstdShuffle, __var_29__ as mt19937, __var_30__ as negativeBinomial, __var_31__ as normal, __var_32__ as pareto1, __var_33__ as poisson, __var_34__ as randi, __var_35__ as randn, __var_36__ as randu, __var_37__ as rayleigh, __var_38__ as t, __var_39__ as triangular, __var_40__ as uniform, __var_41__ as weibull};